import { render, staticRenderFns } from "./RapportProg.vue?vue&type=template&id=5fb2ada4&"
import script from "./RapportProg.vue?vue&type=script&lang=ts&"
export * from "./RapportProg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports